<template>
  <div class="ref-btn ref-btn-md"
       v-on:click="deleteFilter(tag.group, tag.key)" style="display: inline-flex">
    <span v-if="tag.group == 'color'"
          class="ref-btn-text"
          style="width: 20px;height: 20px;"
          v-bind:style="{backgroundColor: '#'+ tag.value}">
    </span>
    <span v-else
          class="ref-btn-text">
      {{tag.value}}
    </span>
    <span class="icon-cancel-2">
      <img src="/res/subdomains/img/light/work-close.svg" alt="close icon"/>
    </span>
  </div>
</template>

<script>
  import TagItemMix from '../../../../components/list/TagItemMix';

  export default {
    name      : 'tag-item-sub',
    mixins: [TagItemMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/TagItemSub.vue